/** Hands the browser a file to save, under the given name. */
export function downloadFile(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");

  link.href = url;
  link.download = filename;
  link.click();

  // A beat later, not straight away: some browsers cancel the download if the
  // object URL goes out from under them before they have read the blob.
  setTimeout(() => {
    URL.revokeObjectURL(url);
  }, 1000);
}
